import { createUseStyles } from 'react-jss';
import { Spacings } from '../../../../foundation/spacings/spacings/index.js';
import { BackgroundColors } from '../../../../foundation/colors/backgroundColors/backgroundColors/index.js';
import { CornerRadius } from '../../../../foundation/cornerRadius/cornerRadius/index.js';
import { Shadows } from '../../../../foundation/colors/shadows/shadows/index.js';

const useStyles = createUseStyles({
    root: {
        padding: ({ isMobile }) => (isMobile ? Spacings.s16 : Spacings.s24),
        position: 'relative',
    },
    holder: {
        padding: Spacings.s24,
        position: 'relative',
        backgroundColor: BackgroundColors.base,
        boxShadow: Shadows,
        borderRadius: CornerRadius.r8,
        border: `1px solid ${BackgroundColors.tint3}`,
    },
    content: {},
    closeButton: {
        '--dirPosition': `calc(-1 * ${Spacings.s16})`,
        position: 'absolute',
        insetBlockStart: 'var(--dirPosition)',
        insetInline: 'auto var(--dirPosition)',
    },
}, {
    name: 'popup',
});

export { useStyles };
